import {_, computed} from '@api'
import {CatalogStore, globalStores, site} from '@stores'
import {CatalogInstanceChildStore} from '@stores/catalog'
import {action, observable} from 'mobx'

export class FilterChipsToolbarStore extends CatalogInstanceChildStore {
  constructor(public catalog: CatalogStore) {
    super(catalog)
  }

  /**
   * Is there anything relevant to show on the bar?
   *
   * The user can optionally turn off the bar in which case we sometimes render things on the topbar instead
   */
  @computed get hasDataToShow() {
    const {catalog, catalog: {settings: {viewMode, activeSearchText}, filter: {hasFilterTerms}, features: {toolbarSwitches}, isGroupedView}} = this

    return hasFilterTerms || !_.isEmpty(activeSearchText) || !_.isEmpty(toolbarSwitches)  //|| (!catalog.stores.isGlobalStore /*&& globalStores.flexLayout.activeCatalogTabs.length > 1*/)
  }

  @action toggleHide = () => {
    this.hide = !this.hide
  }

  @computed get settingsToUse() {
    // return globalStores.catalog.settings // Switch to below if we want individual toolbar toggles in tabs

    const {flexLayout: {showCatalogWidgetsInTopBar}} = this
     if (showCatalogWidgetsInTopBar) {
       return globalStores.catalog.settings
     }

    return this.catalog.settings
  }

  get hide() {
   return !this.settingsToUse.toolbarItems?.filterChips?.visible
  }

  set hide(v: boolean) {
    this.settingsToUse.toolbarItems.filterChips.visible = !v
  }

  @computed get isShowing() {
    return this.hasDataToShow && !this.hide
  }

  @computed get showSlidersInFilterChipsBar() {
    const {catalog: {settings: {toolbarItems: {sliders}}}} = this
    return (sliders.visible && sliders.location === 'secondary') || (!sliders.visible && sliders.location === 'top')
  }

  @computed get showActiveToggles() { return !_.isEmpty(this.catalog.features.toolbarSwitches)}
}



// WEBPACK FOOTER //
// ./src/modules/catalog/FilterChipsToolbar/store.ts